import {DropdownOption} from './types';

export const getMenuOptions = (isAngus: boolean, angusEnabled?: boolean, enableAngus?: () => void): DropdownOption[] => {
  const menuOptions: DropdownOption[] = [];

  if (isAngus) {
    menuOptions.push({
      type: 'link',
      label: 'Angus Help Centre',
      destination: 'https://help.aglive.com/angus-verified/',
    });
  }

  menuOptions.push(
    {
      type: 'link',
      label: 'Aglive Help Centre',
      destination: 'https://help.aglive.com/aglive/',
    },
    {
      type: 'navigation',
      label: 'Health Support',
      destination: '/private/healthSupport',
    },
  );

  if (isAngus) {
    menuOptions.push({
      type: 'checkbox',
      label: 'Use Angus Mobs',
      value: angusEnabled,
      onChange: enableAngus
    });
  }

  return menuOptions;
};
